/* Value passed from django in data attribute goes through `escapejs` to prevent breaking out. The simpliest way to
   decode it is representing it as json containing single string and parsing it with JSON */
export const decodeFormValue = (value) => JSON.parse(`"${value}"`);



// WEBPACK FOOTER //
// ./src/utils/forms.js